const tagTypes = [
  'Employees',
  'Agreements',
  'Projects',
  'Holidays',
  'HolidaysTypes',
  'HolidayRequests',
  'Clients',
  'Countries',
  'Currencies',
  'Addresses',
  'Languages',
  'Banks',
  'Accounts',
  'Auth',
  'BankHolidays',
  'Incomes',
  'Organizations',
  'Costs',
  'HolidayDaysLimits',
  'Positions',
  'Locations',
  'Properties',
  'WorkingHours',
  'GoogleCalendarStatus',
  'GoogleCalendarId',
  'DocumentTypes',
  'Documents',
  'CostGroups',
  'EmployeeProjectRates',
  'PaymentDue',
  'Transactions',
  'ApprovalsCount',
  'HolidaysDaysLimit',
  'PipeDriveLeads',
  'CostsCharts',
  'Benefits',
  'EmployeeBenefits',
  'ClientContacts',
  'Responsibilities',
  'Feedbacks',
  'PropertyBookings',
  'Meetings',
  'ConditionProjects',
  'HolidaysCondition',
  'TaxesCondition',
  'ContractorGroupsCondition',
  'ConditionOrder',
  'CompanyWorkingDays',
  'CompanyDefaultCurrency',
  'CompanyStartDate',
  'InvoicePrefix',
  'CompanyTaxIdNumber',
  'OrganizationBillingAddress',
  'OrganizationBillingPhoneNumber',
  'InvoiceSendCcs',
  'Candidates',
  'TagGroups',
  'ResourceRequests',
  'Tags',
  'TagDefinitions',
  'OrganizationMailFooter',
  'CandidateNotes',
  'ResourceRequestCandidates',
  'OrganizationUsers',
  'OrganizationWeekStartDay',
  'PropertyBookingDaysLimit',
  'Budgets',
  'Budget',
  'BudgetGroups',
  'HolidayTypes',
  'HolidayDaysLimitDefaults',
  'InvoicesSend',
  'Schedules',
  'ScheduleRanges',
  'ScheduleEmployees',
] as const;

export type TagType = typeof tagTypes[number];

export default tagTypes;
